import {defineTextStyles, defineTokens} from "@pandacss/dev"

export const keyframes = {
  slideFromBottom: {
    "0%": {
      transform: "translateY(100%)",
    },
    "100%": {
      transform: "translateY(0%)",
    },
  },
  slideFromTop: {
    "0%": {
      transform: "translateY(0%)",
    },
    "100%": {
      transform: "translateY(100%)",
    },
  },
  fadeInOverlay: {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 0.5,
    },
  },
  fadeOutOverlay: {
    "0%": {
      opacity: 0.5,
    },
    "100%": {
      opacity: 0,
    },
  },
}

export const textStyles = defineTextStyles({
  h1: {
    value: {
      fontSize: 40,
      fontWeight: 700,
      lineHeight: "56px",
    },
  },
  h2: {
    value: {
      fontSize: 32,
      fontWeight: 700,
      lineHeight: "36px",
    },
  },
  h3: {
    value: {
      fontSize: 28,
      fontWeight: 700,
      lineHeight: "32px",
    },
  },
  h4: {
    value: {
      fontSize: 24,
      fontWeight: 700,
      lineHeight: "32px",
    },
  },
  h5: {
    value: {
      fontSize: 18,
      fontWeight: 700,
      lineHeight: "24px",
    },
  },
  body: {
    value: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: "24px",
    },
  },
  body2: {
    value: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "20px",
    },
  },
  button: {
    value: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: "20px",
    },
  },
  button2: {
    value: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "16px",
    },
  },
  caption: {
    value: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: "16px",
    },
  },

  new16: {
    value: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: "24px",
      letterSpacing: "-0.02em",
    },
  },
  // New Fonts
  header: {
    xl: {
      value: {
        fontSize: "60px",
        fontWeight: 300,
        lineHeight: "64px",
      },
    },
    l: {
      value: {
        fontSize: "48px",
        fontWeight: 300,
        lineHeight: "56px",
      },
    },
    m: {
      value: {
        fontSize: "40px",
        fontWeight: 300,
        lineHeight: "48px",
      },
    },
    s: {
      value: {
        fontSize: "32px",
        fontWeight: 300,
        lineHeight: "36px",
      },
    },
    xs: {
      value: {
        fontSize: "24px",
        fontWeight: 300,
        lineHeight: "32px",
      },
    },
  },
  bodyLight: {
    value: {
      fontSize: "16px",
      fontWeight: 300,
      lineHeight: "24px",
    },
  },
  bodyRegular: {
    value: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
  },
  bodyMedium: {
    value: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
    },
  },
  bodyLargeLight: {
    value: {
      fontSize: "18px",
      fontWeight: 300,
      lineHeight: "26px",
    },
  },
  bodyLargeRegular: {
    value: {
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "26px",
    },
  },
  bodyLargeMedium: {
    value: {
      fontSize: "18px",
      fontWeight: 500,
      lineHeight: "26px",
    },
  },
  bodyXLLight: {
    value: {
      fontSize: "20px",
      fontWeight: 300,
      lineHeight: "28px",
    },
  },
  bodyXLRegular: {
    value: {
      fontSize: "20px",
      fontWeight: 400,
      lineHeight: "28px",
    },
  },
  bodyXLMedium: {
    value: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "28px",
    },
  },
  captionRegular: {
    value: {
      fontSize: "13px",
      fontWeight: 400,
      lineHeight: "16px",
    },
  },
  captionMedium: {
    value: {
      fontSize: "13px",
      fontWeight: 500,
      lineHeight: "16px",
    },
  },
  captionAllCaps: {
    value: {
      fontSize: "13px",
      fontWeight: 500,
      lineHeight: "16px",
      textTransform: "uppercase",
    },
  },
})

export const spacing = defineTokens.spacing({
  modalPaddingMobile: {value: "16px"},
  modalPaddingDesktop: {value: "32px"},
})

export const zIndex = defineTokens.zIndex({
  appBackdrop: {value: 1000},
  appModal: {value: 1001},
  sidebarBackdrop: {value: 51},
  sidebar: {value: 52},
  modalBackdrop: {value: 100},
  modal: {value: 101},
  splashScreen: {value: 111},
  mobileMoreButton: {value: 34},
  caseListsDisclaimer: {value: 35},
  mapSearchInputWrapper: {value: 2},
  tooltipPositioner: {value: 100},
  tooltipArrow: {value: -1},
  chatCausesSwitch: {value: 50},
  causes: {
    bg: {value: 1},
    content: {value: 3},
    container: {value: 1},
    sparkle: {value: 5},
    peek: {value: 100},
  },
  bgPattern: {
    base: {value: 0},
    middle: {value: 1},
    top: {value: 2},
  },
  remediations: {
    backButton: {value: 1},
  },
})
